<template>
  <div>
    <sample-header>
    </sample-header>
    <div class="content homepage" v-if="loaded && !hasError">
      <!--<div class="homepage__gradient">-->
        <div class="homepage__hero">
          <div class="center-content">
            <div class="hero-rebate">
              <div class="text-header row">
                <div class="columns small-12">
                  <h1>Ready to order your Evaluation Product?</h1>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="columns small-12">
                <div class="choice-text">
                  <br/>
                  <p style="color:white;">Choose the type of lens you wear</p>
                  <br/>
                </div>
                <div class="pad-before-footer">
                  <div class="row small-up-1" :class="{'medium-up-2': choices && choices.length % 2 === 0}">
                    <div class="column column-block text-center" v-for="c in choices">
                      <router-link :to="{ name: 'coupon_validator', query: {programChoice:  c.lensProgramId}, params: { couponCode: couponCode }}">
                        <span v-html="c.choiceText"></span>
                      </router-link>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      <!--</div>-->
    </div>
    <div v-else>
      <loading-indicator message='Getting your choices' v-if="!loaded"></loading-indicator>
    </div>
    
    <div v-if="hasError" class="error-container">
      <div v-html="errorMessage"></div>
      <router-link to="/">Back to Home</router-link>
    </div>

    <sample-footer>
    </sample-footer>
  </div>
</template>

<script>
import SampleHeader from "@/components/layout/SampleHeader";
import SampleFooter from "@/components/layout/SampleFooter";
import Vue from "vue";
import LoadingIndicator from "@/components/layout/LoadingIndicator";

let MSG_ServerError = `<p>We are unable to process this code at this time.  
Verify you are online and please try again later.  
If the problem persists please email our support team at 
<a href="mailto:EvaluationCS@essilorusa.com?subject=Error on site">EvaluationCS@essilorusa.com </a></p>
`;

let MSG_NoMatch = `The redemption code you have entered is incorrect. 
Please check it one more time. 
If you still get an error, please email our support team at 
<a href="mailto:EssilorEvaluationProductSupport@essilorusa.com?subject=Invalid redemption code">EssilorEvaluationProductSupport@essilorusa.com</a></p>
`;

let MSG_Redeemed = `Please check the redemption code you have entered. 
The code you have entered has already been used. 
Please email our support team at 
<a href="mailto:EvaluationCS@essilorusa.com?subject=Invalid redemption code">EvaluationCS@essilorusa.com</a></p>
`;

let MSG_Expired = `This redemption code is already expired. Please email our support team at 
<a href="mailto:EssilorEvaluationProductSupport@essilorusa.com?subject=Redemption code expired">EssilorEvaluationProductSupport@essilorusa.com</a></p>
`;

function interpretStatus(status) {
  switch (status) {
    case "NOT_FOUND":
      return MSG_NoMatch;
      break;

    case "REDEEMED":
      return MSG_Redeemed;
      break;

    case "EXPIRED":
      return MSG_Expired;
      break;
  }
}

export default {
  props: ["couponCode", "programChoice"],
  components: { SampleHeader, SampleFooter, LoadingIndicator },
  data() {
    return {
      choices: [],
      hasError: false,
      loaded: false
    };
  },

  methods: {
    navtoOrder() {
      this.$router.push("/order/" + this.couponCode);
    },
    processCode(couponData) {
      if (couponData.programDetails.marketingPageName) {
        axios
          .get(
            Vue.config.HOST_URL + couponData.programDetails.marketingPageName,
            {
              responseType: "text"
            }
          )
          .then(response => {
            this.marketingContent = response.data;
            this.loaded = true;
          });
      } else {
        this.navtoOrder();
      }
    },

    applyError(msg) {
      this.hasError = true;
      this.errorMessage =
        "<div><h1>Unable to process this code</h1><p>" + msg + "</p></div>";
      this.loaded = true;
    },
    codeValid() {
      return (
        this.couponCode && this.couponCode.length === "xxxxx-xxx-xxx-xxx".length
      );
    },
    handleLoadError(error) {
      if (error.response && error.response.status == "404") {
        this.applyError(interpretStatus("NOT_FOUND"));
      } else {
        this.applyError(MSG_ServerError);
      }
    },
    loadChoices() {
      axios
        .get("/coupon/" + this.couponCode)
        .then(response => {
          if (response && (response.data.programDetails.programType === "Employee" || response.data.programDetails.programType === "SalesRep")) {
            this.applyError(interpretStatus("NOT_FOUND"));
          }
          this.choices = response.data.lensProgramChoices;
          this.loaded = true;
        })
        .catch(error => {
          this.handleLoadError(error);
        });
    }
  },
  created() {
    this.loadChoices();
  }
};
</script>
<style>
.create-order-button {
  margin-top: 25px;
  margin-bottom: 35px;
  width: 300px;
}

.choice-text {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
}

.button {
  border-radius: 4px;
  border: 0;
  display: inline-block;
  background-color: #00f;
  padding: 15px 30px;
  text-decoration: none;

  color: #fff;
  font-size: 12pt;
  font-family: "Montserrat", Helvetica, Arial, san-serif;
}

@media only screen and (max-width: 640px) {
  .button {
    max-width: 400px;
  }
}
.error-container {
  text-align: center;
  margin-top: 150px;
  margin-bottom: 150px;
}

</style>
